// extracted by mini-css-extract-plugin
module.exports = {"container":"MyFYhmbzyFwAJoSrvdluG","spinner":"_54iVlEa5EVqUds9XJLGZd","loading-spinner-animation":"_1bmfqNQ2M6SC54fvGInRvp"};